export const getLastEdokFormId = state => state.edok.lastInteractiveId;